import { useQuery } from '@apollo/client';
import { usePaginationAndFilter } from 'components/template/ListTemplate/hooks/usePaginationAndFilter';
import { GRAPHQL_BUSCAR_USUARIO_LOGS } from 'gql/usuarioLog';
import { useEffect, useMemo } from 'react';
import JSON_DATA_FILTER from '../../data/filter.json';
import { IQueryUsuarioLogs } from './index.d';

export const useQueryFilterUsuarioLogs = () => {
    const dataSelectHeader = useMemo(() => JSON_DATA_FILTER, []);

    const props = usePaginationAndFilter({
        dataKeyName: 'dataRegistroInicio',
        keysQueryVariavel: [
            'usuario',
            'estabelecimento',
            'acao',
            'status',
            'dataRegistroInicio',
        ],
    });

    const variables = useMemo(() => {
        const filter = { ...(props.variables?.filter || {}) };
        if (filter.dataRegistroInicio && !filter.dataRegistroFim) {
            filter.dataRegistroFim = filter.dataRegistroInicio;
        }

        return { filter };
    }, [props.variables]);

    const { loading } = useQuery<IQueryUsuarioLogs>(GRAPHQL_BUSCAR_USUARIO_LOGS, {
        context: props.context,
        variables,
        onCompleted: ({ usuarioLogs }) => props.onCompleted(usuarioLogs),
        onError: props.onError,
    });

    useEffect(() => {
        props.setLoading(loading);
    }, [loading]);

    return {
        ...props,
        variables,
        addFilterDate: true,
        dataSelectHeader,
    };
};
